import script from "./chat.vue?vue&type=script&setup=true&lang=js"
export * from "./chat.vue?vue&type=script&setup=true&lang=js"

import "./chat.vue?vue&type=style&index=0&id=7fee5ec4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fee5ec4"]])

export default __exports__